<template>
  <div class="p-2">
    <p
      class="
        uppercase
        text-2xl
        font-OswaldFont
        text-blue-900
        mb-5
        pl-2
        border-l-8 border-blue-900
      "
    >
      Other articles
    </p>
    <div class="grid xl:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-3">
      <div v-for="article in articles" :key="article.id">
        <p
          class="
            bg-gray-100
            p-2
            rounded
            uppercase
            font-OswaldFont
            text-lg
            gap-y-5
            cursor-pointer
            border
            hover:border-STorange
            font-thin
            truncate
          "
          @click="handleClick(article.id)"
        >
          {{ article.header }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherArticles",

  props: {
    articles: Array,
  },

  methods: {
    handleClick(id) {
      this.$router.push({
        name: "ArticlesPage",
        params: { id },
      });

      window.location.reload();
    },
  },
};
</script>
